import Vue from 'vue';
import Component from 'vue-class-component';

import arrowIcon from 'assets/icons/Chevron_red.svg';
import useFilters from 'composables/useFilters';
import useCatalogFilters from 'composables/useCatalogFilters';

import orderOptions from 'constants/orderOptions';

@Component({
  props: {
    isBoxCatalog: {
      type: Boolean,
      default: false,
    },
  },
  setup(props) {
    const filterStore = props.isBoxCatalog ? useCatalogFilters() : useFilters();
    const { handleChangeFilters, getCurrentOrder } = filterStore;
    return {
      handleChange: handleChangeFilters,
      getCurrentOrder,
    };
  },
})
export default class OrderByComponent extends Vue {
  orderOptions = orderOptions;

  get _orderOptions() {
    if (!this.orderOptions) return [];

    return this.isBoxCatalog
      ? this.orderOptions.boxCatalogOptions
      : this.orderOptions.nonBoxCatalogOptions;
  }

  icons = {
    arrow: arrowIcon,
  };

  showList = false;

  toggleShowList() {
    this.showList = !this.showList;
  }

  isSelected(option) {
    return option === this.selectedOrder.title;
  }

  get selectedOrder() {
    return (
      this._orderOptions.find(
        option => option.value === this.getCurrentOrder,
      ) || this._orderOptions[0]
    );
  }

  selectOrder(option) {
    this.handleChange(option.value, 'orderBy');
    this.toggleShowList();
  }
}
